export default {
  Landing: '/',
  About: '/about'
};
